import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Button,
} from '@material-ui/core';
import api from 'utils/api';
import { FormField2 as Field, CommonDialog, } from 'components';
import _ from 'lodash';

const useStyles = makeStyles({
  root: {},
  bold: {
    fontWeight: 'bold',
  },
  textCenter: {
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: 12,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '& thead tr': {
      '& td, th': {
        border: '1px solid #ddd',
        padding: 8,
      },
    },

    '& tbody tr': {
      '&:not(.no-hover):hover': {
        backgroundColor: '#d9d9d9',
        cursor: 'pointer',
      },

      '& td, th': {
        border: '1px solid #ddd',
        padding: 8,
      },
    },

    '& input[type="number"], input[type="text"]': {
      textAlign: 'right',
      border: '1px solid #316ac5',
      borderRadius: '4px',
      margin: '2px 0px',

      '&[disabled]': {
        border: '1px solid #cccccc',
      }
    },

    '& input[type="text"]': {
      borderColor: '#c4c4c4',
      padding: '6px 6px 7px',
      color: '#12161b',
      textAlign: 'left',
    },
  },
});

const EstimateSummaryCalculationSettingsModal = ({
  summaryId,
  settings,
  fetchRecord,
  onClose,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [numbersAfterDecimal, setNumbersAfterDecimal] = useState(settings?.numbersAfterDecimal);

  const handleNumbersAfterDecimalUpdate = async () => {
    try {
      if (settings.numbersAfterDecimal === numbersAfterDecimal) return;

      await api.put(`/estimate-summaries/${summaryId}/`, { settings: { ...settings, numbersAfterDecimal: parseInt(numbersAfterDecimal)}});
      await fetchRecord(summaryId)
      onClose(false);
    } catch (err) {
      console.error(err);
    }
  }
  const options = [0, 1, 2, 3].map(number => ({ value: number?.toString(), label: number?.toString() }));

  return (
    <CommonDialog
        visible
        onClose={onClose}
        showClose
        maxWidth="lg"
        style={{ position: 'relative' }}
        title={t('Skaičiavimų nustatymai')}
      >
      <table className={classes.table}>
        <tbody>
            <tr key={settings?.numbersAfterDecimal}>
              <td style={{ width: '70%' }} >{t('Kainos ženklų skaičius po kablelio')}</td>
              <td style={{ width: '20%', padding: '2px 8px' }}>
                <Field
                  type="select"
                  name="value"
                  value={numbersAfterDecimal?.toString()}
                  options={options}
                  onChange={({ value }) => setNumbersAfterDecimal(value)}
                  naked
                />
              </td>
              <td style={{ width: '10%', padding: '2px 8px' }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleNumbersAfterDecimalUpdate}
                  disabled={settings?.numbersAfterDecimal == numbersAfterDecimal}
                >
                  {t('Perskaičiuoti')}
                </Button>
              </td>
            </tr>
        </tbody>
      </table>
    </CommonDialog>
  )
}

export default EstimateSummaryCalculationSettingsModal;